import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ChatMenuComponentService {
  isExpanded$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  toggle(): void {
    this.isExpanded$.next(!this.isExpanded$.getValue());
  }

  close(): void {
    this.isExpanded$.next(false);
  }
}
